import {
	API_SEARCH_POSTALCODE	
} from 'actions/postalCode.js';

export function searchPostalCodes(searchData, size, start) {
	return {
		type: API_SEARCH_POSTALCODE,
		payload: {
			request: {
				url: `/postalcodes/search/${size}/${start}`,
				method: 'GET',
				params: searchData
			}
		}
	};
}
